import $api from "../api";

export default class OfferService {
    static async getAll(params = {}) {
        const query = new URLSearchParams();

        for (const [key, value] of Object.entries(params)) {
            if (value == null || value === "") continue;
            query.append(key, value)
        }

        const { data } = await $api.get('/offers/all?' + query);
        return data;
    }

    static async generate({ text, threadId = null }) {
        const { data } = await $api.post('/offers/generate', { text, threadId });
        return data;
    }

    static async getPrompt() {
        const { data } = await $api.get('/offers/get_prompt');
        return data;
    }

    static async updatePrompt(newPrompt) {
        const { data } = await $api.post('/offers/update_prompt', { newPrompt });
        return data;
    }

    static async save(offers, thread) {
        const { data } = await $api.post('/offers/save', { offers, thread });
        return data;
    }

    static async update(id, offer) {
        const { data } = await $api.patch(`/offers/update/${id}`, offer);
        return data;
    }

    static async delete(offersId) {
        const query = new URLSearchParams();
        query.append('offersId', offersId?.join(',') || []);
        
        const { data } = await $api.delete('/offers/delete?' + query.toString());
        return data;
    }
}